import { Controller } from "@hotwired/stimulus"

// Booking page: reloads the "availability" Turbo Frame as soon as the party
// size or the date changes (the GET form targets the frame).
//
// <div data-controller="booking">
//   <form data-booking-target="search" data-action="change->booking#search" data-turbo-frame="availability">
export default class extends Controller {
  static targets = ["search"]

  search() {
    const date = this.searchTarget.querySelector("input[type=date]")
    if (date && !date.value) return
    this.searchTarget.requestSubmit()
  }
}
